
export const inspirationProjects = [
  {
    id: 1,
    title: 'Luxe Penthouse Amsterdam',
    location: 'Amsterdam, Nederland',
    category: 'residential',
    model: 'Royal Diamond 152cm',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1_774bf3ad-1297-4eaf-b41e-f1f18df8e26a.png',
    description: 'Een prachtig penthouse met een Royal Diamond 152cm inbouwhaard als centraal element in de woonkamer.'
  },
  {
    id: 2,
    title: 'Boutique Hotel Berlin',
    location: 'Berlin, Deutschland',
    category: 'hospitality',
    model: 'Mazar 3D 183cm',
    image: 'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
    description: 'Luxe hotellobby met een driezijdige Mazar 3D haard die vanuit elke hoek zichtbaar is.'
  },
  {
    id: 3,
    title: 'Executive Office Rotterdam',
    location: 'Rotterdam, Nederland',
    category: 'commercial',
    model: 'Decori 183cm',
    image: 'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
    description: 'Modern kantoor met een strakke Decori Slimline haard in de executive lounge.'
  },
  {
    id: 4,
    title: 'Fine Dining Restaurant Brussel',
    location: 'Brussel, België',
    category: 'hospitality',
    model: 'Deep Diamond 160cm',
    image: 'https://diamondflame.nl/cdn/shop/files/DeepDiamondhaard.jpg?v=1759795057',
    description: 'Exclusief restaurant met een Deep Diamond driezijdige haard voor een warme ambiance.'
  },
  {
    id: 5,
    title: 'Villa München',
    location: 'München, Deutschland',
    category: 'residential',
    model: 'Royal Diamond 254cm',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
    description: 'Ruime villa met een extra brede Royal Diamond 254cm haard in de woonkamer.'
  },
  {
    id: 6,
    title: 'Premium Showroom Paris',
    location: 'Paris, France',
    category: 'commercial',
    model: 'Fortuna 60cm',
    image: 'https://diamondflame.nl/cdn/shop/files/Fortuna1.png?v=1705969157',
    description: 'Elegante showroom met een compacte Fortuna 60cm haard als eyecatcher.'
  },
  {
    id: 7,
    title: 'Spa & Wellness Resort Zürich',
    location: 'Zürich, Schweiz',
    category: 'hospitality',
    model: 'Decori 152cm',
    image: 'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
    description: 'Luxe wellness resort met Decori haarden in de relaxruimtes.'
  },
  {
    id: 8,
    title: 'Modern Appartement Kopenhagen',
    location: 'Kopenhagen, Danmark',
    category: 'residential',
    model: 'Royal Diamond 127cm',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
    description: 'Stijlvol appartement met een Royal Diamond 127cm haard in de woonkamer.'
  },
  {
    id: 9,
    title: 'Designhotel Lobby Milaan',
    location: 'Milaan, Italia',
    category: 'hospitality',
    model: 'Mazar 3D 254cm',
    image: 'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
    description: 'Designhotel met een imposante Mazar 3D 254cm haard in de lobby.'
  },
  {
    id: 10,
    title: 'Privé Cinema Room Londen',
    location: 'Londen, United Kingdom',
    category: 'residential',
    model: 'Modern Steel 183cm',
    image: 'https://diamondflame.nl/cdn/shop/files/ModernSteel1.png?v=1705969896',
    description: 'Luxe thuisbioscoop met een Modern Steel 183cm haard in de cinewall.'
  },
  {
    id: 11,
    title: 'Corporate Headquarters Frankfurt',
    location: 'Frankfurt, Deutschland',
    category: 'commercial',
    model: 'Deep Diamond 220cm',
    image: 'https://diamondflame.nl/cdn/shop/files/DeepDiamondhaard_79e1bf72-c325-4cb6-a105-cc386b2874ca.jpg?v=1759795062',
    description: 'Modern hoofdkantoor met een Deep Diamond 220cm haard in de boardroom.'
  },
  {
    id: 12,
    title: 'Chalet de Luxe Chamonix',
    location: 'Chamonix, France',
    category: 'residential',
    model: 'Verdi Fires',
    image: 'https://sfeerhaardkopen.com/cdn/shop/files/VerdiFires0.jpg?v=1766689629',
    description: 'Luxe bergchalet met een vrijstaande Verdi Fires haard voor authentieke sfeer.'
  }
];
